import Button from '@/components/Button';
import ensureSelectedFilterOptions from '@/components/modals/workflowLogsModal/lib/ensureSelectedFilterOptions';
import useWorkflowLogsFilters from '@/components/modals/workflowLogsModal/lib/useWorkflowLogsFilters';
import { LuContainer } from '@/components/react-icons/main/index.esm';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const EnvironmentFilter = () => {
  const workflowId = useArgSelector(selectors.workflowId);
  const workflowLogsMetadataEnvironments = useSelector(selectors.workflowLogsMetadataEnvironments);
  const environmentFilter = useArgSelector(selectors.pref, `workflowLogsEnvironmentFilter-${workflowId}`);
  const environments = useSelector(selectors.environments) || [];
  const { handleFilterChange } = useWorkflowLogsFilters();

  const hasEnvironmentFilter = environmentFilter?.length > 0;

  const environmentOptions = useMemo(() => {
    const options = workflowLogsMetadataEnvironments
      ?.map((metadata) => ({ label: metadata?.label, value: metadata?.id, totalCount: metadata?.totalCount }))
      .filter(Boolean)
      .sort((a, b) => b.totalCount - a.totalCount);

    return ensureSelectedFilterOptions({
      options,
      selectedValues: environmentFilter,
      getSelectedOption: (value) => {
        const environment = environments.find((item) => item.id === value);
        return { label: environment?.name || value };
      }
    });
  }, [workflowLogsMetadataEnvironments, environmentFilter, environments]);

  const handleEnvironmentChange = (value) => {
    handleFilterChange('environment', value);
  };

  return (
    <>
      <Button className={`outline filter environment-filter ${hasEnvironmentFilter ? 'active' : ''}`} size="sm" icon={LuContainer}>
        Environment
      </Button>
      <FloatingSelectV2 multiple triggers={[`.environment-filter`]} options={environmentOptions} onChange={handleEnvironmentChange} useSearch={environmentOptions?.length > 5} value={environmentFilter} placement="bottom" offset={4} />
    </>
  );
};

export default EnvironmentFilter;
